module.exports = __webpack_public_path__ + "./fonts/lato-light-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/lato-light-webfont.ttf
// module id = 21
// module chunks = 0